import { render, staticRenderFns } from "./TableCurrenShip.vue?vue&type=template&id=264e36a0&scoped=true&"
import script from "./TableCurrenShip.vue?vue&type=script&lang=js&"
export * from "./TableCurrenShip.vue?vue&type=script&lang=js&"
import style0 from "./TableCurrenShip.vue?vue&type=style&index=0&id=264e36a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e36a0",
  null
  
)

export default component.exports